import { createContext, useContext, useMemo, useEffect, useRef } from 'react';

var WindowContext = createContext(window);
var Provider = WindowContext.Provider,
    Consumer = WindowContext.Consumer;

var useWindow = function useWindow() {
  return useContext(WindowContext);
};

var DocumentContext = createContext(document);
var Provider$1 = DocumentContext.Provider,
    Consumer$1 = DocumentContext.Consumer;

var useDocument = function useDocument() {
  return useContext(DocumentContext);
};

var usePromise = function usePromise(deps) {
  return useMemo(function () {
    var resolve, reject;
    var promise = new Promise(function (res, rej) {
      resolve = res;
      reject = rej;
    });
    return [promise, resolve, reject];
  }, deps);
};

var useAsyncEffect = function useAsyncEffect(cb, deps) {
  return useEffect(function () {
    cb();
  }, deps);
};

var useSkipEffect = function useSkipEffect(n, effect, deps) {
  var ref = useRef(0);
  useEffect(function () {
    if (ref.current < n) {
      ref.current = ref.current + 1;
      return;
    }

    effect();
  }, deps);
};

export { Provider$1 as DocumentProvider, Provider as WindowProvider, useAsyncEffect, useDocument, usePromise, useSkipEffect, useWindow };
